export function pillNodeSpec() {
    return {
        pill: {
            group: "inline",
            inline: true,
            atom: true,
            selectable: false,
            attrs: {
                icon: { default: null },
                title: { default: null },
                value: { default: null },
                invalid: { default: false },
                tooltip: { default: null },
            },
            parseDOM: [
                {
                    tag: "span.editor-pill",
                    getAttrs: (dom) => ({
                        title: dom.getAttribute("title"),
                        icon: dom.getAttribute("data-icon"),
                        value: dom.getAttribute("data-value"),
                        invalid: dom.getAttribute("data-invalid") === "true",
                        tooltip: dom.getAttribute("data-tooltip"),
                    }),
                },
            ],
            toDOM: (node) => {
                const { title, icon, value, invalid, tooltip } = node.attrs;
                return [
                    "span",
                    {
                        class: "editor-pill",
                        title,
                        "data-icon": icon,
                        "data-value": value,
                        "data-invalid": (invalid === null || invalid === void 0 ? void 0 : invalid.toString()) || "false",
                        "data-tooltip": tooltip,
                    },
                    title,
                ];
            },
        },
    };
}
